
export enum HarmingYourselfOrOthers { 
    noneToBoth = 0,
    harmingMyself = 1,
    harmingOthers = 2,
    yesToBoth = 3
}

